var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"consent-container"},[_c('div',{class:['consent', _vm.computedClasses],domProps:{"innerHTML":_vm._s(_vm.consent.message)}}),_c('span',{staticClass:"btn-tgl-expand",on:{"click":_vm.toggleExpand}},[_vm._v(" "+_vm._s(this.isExpanded ? 'see less' : 'see more')+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }